import {
	LOGOUT,
	RECEIVE_POST_NEW_APPLICATION,
	RECEIVE_PATCH_APPLICATION
} from "../actions/index";

const defaultState = {
	postedApplication: {}
};

export default (state = defaultState, action) => {
	switch (action.type) {
		case RECEIVE_PATCH_APPLICATION:
            return {
                postedApplication:action.payload
            };
		case RECEIVE_POST_NEW_APPLICATION:
			return {
				postedApplication:action.payload
			};
		case LOGOUT:
			return {
				...defaultState
			};
		case '@@router/CALL_HISTORY_METHOD':
			return {
				...defaultState
			};
		default:
			return {
				...state
			}
	}
}